module.exports = __webpack_public_path__ + "img/Warrior-dwarf-f-70.a48948f5.gif";